import React from 'react'

const Share = props => (
  <svg height={16} width={16} fill={props.fill} viewBox="0 0 16 16" {...props}>
    <path
      d="M12 0a2.412 2.412 0 00-2.4 2.4c0 .153.017.302.045.447l-5.707 3.33A2.375 2.375 0 002.4 5.6 2.412 2.412 0 000 8c0 1.316 1.084 2.4 2.4 2.4.586 0 1.119-.222 1.538-.577l5.707 3.329a2.365 2.365 0 00-.045.448c0 1.316 1.084 2.4 2.4 2.4s2.4-1.084 2.4-2.4-1.084-2.4-2.4-2.4a2.37 2.37 0 00-1.537.578L4.755 8.447c.028-.145.045-.294.045-.447s-.017-.302-.045-.447l5.708-3.33c.418.355.951.577 1.537.577 1.316 0 2.4-1.084 2.4-2.4S13.316 0 12 0zm0 1.6c.451 0 .8.349.8.8s-.349.8-.8.8a.788.788 0 01-.8-.8c0-.451.349-.8.8-.8zM2.4 7.2c.451 0 .8.349.8.8s-.349.8-.8.8a.788.788 0 01-.8-.8c0-.451.349-.8.8-.8zm9.6 5.6c.451 0 .8.349.8.8s-.349.8-.8.8a.788.788 0 01-.8-.8c0-.451.349-.8.8-.8z"
    />
  </svg>
)

export default Share
